export enum ATX_DEVICE_SIZE {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  XXL = 'XXL',
}

export const ATX_DEVICE_SIZES: ATX_DEVICE_SIZE[] = [
  ATX_DEVICE_SIZE.XS,
  ATX_DEVICE_SIZE.SM,
  ATX_DEVICE_SIZE.MD,
  ATX_DEVICE_SIZE.LG,
  ATX_DEVICE_SIZE.XL,
  ATX_DEVICE_SIZE.XXL,
];

export const ATX_DEVICE_SIZE_CLASS: { [key in ATX_DEVICE_SIZE]: string } = {
  XS: 'is-xs',
  SM: 'is-sm',
  MD: 'is-md',
  LG: 'is-lg',
  XL: 'is-xl',
  XXL: 'is-xxl',
};

export const ATX_DEVICE_SIZE_UP_CLASS: { [key in ATX_DEVICE_SIZE]: string } = {
  XS: 'is-xs-up',
  SM: 'is-sm-up',
  MD: 'is-md-up',
  LG: 'is-lg-up',
  XL: 'is-xl-up',
  XXL: 'is-xxl-up',
};

export const ATX_DEVICE_SIZE_DOWN_CLASS: { [key in ATX_DEVICE_SIZE]: string } =
  {
    XS: 'is-xs-down',
    SM: 'is-sm-down',
    MD: 'is-md-down',
    LG: 'is-lg-down',
    XL: 'is-xl-down',
    XXL: 'is-xxl-down',
  };

export const ATX_BREAKPOINT_CLASSES = [
  ...ATX_DEVICE_SIZES.map((size) => ATX_DEVICE_SIZE_CLASS[size]),
  ...ATX_DEVICE_SIZES.map((size) => ATX_DEVICE_SIZE_UP_CLASS[size]),
  ...ATX_DEVICE_SIZES.map((size) => ATX_DEVICE_SIZE_DOWN_CLASS[size]),
];

export const ATX_BREAKPOINT_WIDTH: { [key in ATX_DEVICE_SIZE]: number } = {
  XS: 0,
  SM: 576,
  MD: 769,
  LG: 992,
  XL: 1200,
  XXL: 1880,
};

export const ATX_BREAKPOINT_MEDIA: { [key in ATX_DEVICE_SIZE]: string } = {
  XS: `(max-width: ${ATX_BREAKPOINT_WIDTH.SM - 1}px)`,
  SM: `(min-width: ${ATX_BREAKPOINT_WIDTH.SM}px)`,
  MD: `(min-width: ${ATX_BREAKPOINT_WIDTH.MD}px)`,
  LG: `(min-width: ${ATX_BREAKPOINT_WIDTH.LG}px)`,
  XL: `(min-width: ${ATX_BREAKPOINT_WIDTH.XL}px)`,
  XXL: `(min-width: ${ATX_BREAKPOINT_WIDTH.XXL}px)`,
};
